var map = {
	"./arrow_next.svg": 653,
	"./arrow_prev.svg": 654,
	"./calendar.svg": 655,
	"./case.svg": 656,
	"./clock.svg": 657,
	"./close.svg": 658,
	"./hd.svg": 659,
	"./heart.svg": 660,
	"./impress.svg": 661,
	"./menu.svg": 662,
	"./move.svg": 663,
	"./pen.svg": 664,
	"./processor.svg": 665,
	"./right-arrow-angle.svg": 666,
	"./timer.svg": 667,
	"./watch.svg": 668,
	"./weigher.svg": 669,
	"./windows.svg": 670
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icons nonrecursive \.svg$
// module id = 674
// module chunks = 1